<template>
  <!-- Loading -->
  <div class="vld-parent">
      <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
  </div>

  <div class="shadow overflow-hidden">
    <div>
      <dl>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('vaccines.start_date') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ assignment.start_date }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('vaccines.end_date') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ assignment.end_date }}
          </dd>
        </div>

        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            Program
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ assignment.program }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            Position
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ assignment.position }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            Job Description
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ assignment.description }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            Assignment Date
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ assignment.assignment_date }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-1 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            <a class="bg-blue-700 hover:bg-blue-700 text-white font-bold py-2 px-4" :href="assignment.filename" download="assignment.pdf">
              Download PDF
            </a>
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            <vue-pdf-embed :source="pdfSource" />
          </dd>
        </div>

      </dl>

    </div>

  </div>

</template>
<script>
/* eslint-disable */
import { ref, reactive, watchEffect } from 'vue'
import { axiosDocument } from "@/boot/axios";
import VuePdfEmbed from 'vue-pdf-embed'
import Loading from 'vue-loading-overlay'
export default {
  name: 'ClassForm',
  components: {
    Loading,
    VuePdfEmbed
  },
  props: {
    propObject: {
        type: Object,
        default: () => ({ empty: true })
    }
  },
  data: function () {
    return {
    }
  },
  emits: ['close-modal', 'submit'],
  setup (props, { emit }) {
    const titleStack = ref(['Admin', 'Forms'])

    const assignment = ref({})
    const isLoading = ref(false)

    // if doc academic active = true
    const storeDoc = (env) => {
        const url = 'doc-file-getEmployee'
        const method = 'POST'

        isLoading.value = true
        const paramsData = { id: env }

        const jsonData = JSON.stringify(paramsData)
        console.log('paramsData DOC', paramsData)

        const configHeaders = {
            'content-type': 'application/json',
            Accept: 'application/json'
        }

        axiosDocument({
            method,
            url,
            data: jsonData,
            headers: configHeaders
        })
        .then(response => {
            isLoading.value = false
            pdfSource.value = response.data.data
            console.log('pdfSource.value', pdfSource.value)
        })
        .catch(error => {
            isLoading.value = false
            console.log('error', error)
        })
    }

    const pdfSource = ref(null)
    watchEffect(() => {
      assignment.value = props.propObject

      if (assignment.value && assignment.value.filename) {
        pdfSource.value = assignment.value.filename
      }
      
      if(assignment.value && assignment.value.is_doc > 0){
        storeDoc(assignment.value.id)
      }
    })

    return {
      isLoading,
      storeDoc,
      titleStack,
      assignment,
      pdfSource

    }
  }
}
</script>